import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from './store';
import { OnboardDeviceHardwareConfiguration } from '../interfaces';
import { getOnboardDevicesHardwareConfigurations } from '../api/getOnboardDevicesHardwareConfigurations';

export interface OnboardDeviceHardwareConfigurationsState {
    items: OnboardDeviceHardwareConfiguration[] | null;
    selectedRows: string[];
}

const initialState: OnboardDeviceHardwareConfigurationsState = {
    items: null,
    selectedRows: [],
};

export const loadOnboardDevicesHardwareConfigurations = createAsyncThunk(
    'onboardDeviceHardwareConfigurations/load',
    async () => {
        return await getOnboardDevicesHardwareConfigurations();
    },
);

export const OnboardDeviceHardwareConfigurationsSlice = createSlice({
    name: 'onboardDeviceHardwareConfigurations',
    initialState,
    reducers: {
        setSelectedOnboardHardwareConfigurationRows: (state, action: PayloadAction<string[]>) => {
            state.selectedRows = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadOnboardDevicesHardwareConfigurations.fulfilled, (state, action) => {
                state.items = action.payload;
            })
            .addCase(loadOnboardDevicesHardwareConfigurations.rejected, (state, action) => {
                console.error(action.error);
            });
    },
});

export const { setSelectedOnboardHardwareConfigurationRows } =
    OnboardDeviceHardwareConfigurationsSlice.actions;

export const selectOnboardDevicesHardwareConfigurations = (state: RootState) =>
    state.onboardDeviceHardwareConfigurations.items;
export const selectSelectedOnboardHardwareConfigurationRows = (state: RootState) =>
    state.onboardDeviceHardwareConfigurations.selectedRows;

export default OnboardDeviceHardwareConfigurationsSlice.reducer;
